import { useState } from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'

const SpecificationFilters = ({ specifications, onFilterChange }) => {
  const [filters, setFilters] = useState({})

  const handleSpecChange = (specId, value) => {
    const newFilters = { ...filters }

    if (value === 'all') {
      delete newFilters[specId]
    } else {
      newFilters[specId] = value
    }

    setFilters(newFilters)
    onFilterChange(newFilters)
  }

  const clearFilters = () => {
    setFilters({})
    onFilterChange({})
  }

  if (!specifications?.length) return null

  return (
    <div className="flex flex-wrap items-center gap-3" dir="rtl">
      {specifications.map((spec) => (
        <Select
          key={spec.id}
          value={filters[spec.id] || 'all'}
          onValueChange={(value) => handleSpecChange(spec.id, value)}
          className="w-fit px-6"
        >
          <SelectTrigger>
            <SelectValue placeholder={spec.name} />
          </SelectTrigger>
          <SelectContent dir="rtl" className="w-fit">
            <SelectItem value="all">{spec.name}</SelectItem>
            {spec.available_values?.filter(v => v && v.trim() !== '').map((value, idx) => (
              <SelectItem key={idx} value={String(value)}>
                {value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ))}

      {Object.keys(filters).length > 0 && (
        <Button
          variant="ghost"
          size="icon"
          onClick={clearFilters}
          className="shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}

export default SpecificationFilters